import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Box, Card, useTheme } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import LectureContentItem from './LectureContentItem';

export default function LectureContentSelector({ items = [], item, setItem }) {
  const theme = useTheme();
  const scrollContainerRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  const checkOverflow = () => {
    const container = scrollContainerRef.current;
    if (container) {
      const isOverflowing = container.scrollWidth > container.clientWidth;
      const isAtStart = container.scrollLeft <= 0;
      const isAtEnd =
        container.scrollLeft + container.clientWidth >=
        container.scrollWidth - 1;

      setShowLeftArrow(isOverflowing && !isAtStart);
      setShowRightArrow(isOverflowing && !isAtEnd);
    }
  };

  useEffect(() => {
    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, []);

  const scroll = (direction) => {
    const container = scrollContainerRef.current;
    if (container) {
      const scrollAmount = direction === 'left' ? -200 : 200;
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      setTimeout(checkOverflow, 300);
    }
  };

  return (
    <Card
      sx={{
        p: 1,
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        gap: 1,
        overflow: 'hidden',
        position: 'relative',
      }}
    >
        <Box
          onClick={() => scroll('left')}
          sx={{
            borderRadius: 1,
            py: 1,
            px: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: showLeftArrow && 'pointer',
            userSelect: 'none',
            backgroundColor: theme.palette.background.paper,
            '&:hover': showLeftArrow && {
              backgroundColor: theme.palette.action.hover,
            },
            '&:active': showLeftArrow && {
              backgroundColor: theme.palette.action.selected,
            },
            color: !showLeftArrow && theme.palette.text.disabled,
          }}
        >
          <ChevronLeft sx={{ fontSize: 20 }} />
        </Box>
      <Box
        ref={scrollContainerRef}
        onScroll={checkOverflow}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 1,
          overflowX: 'auto',
          scrollbarWidth: 'none',
          flex: 1,
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
      >
        {items.map((it, index) => (
          <LectureContentItem
            key={index}
            completed={it.completed}
            active={it.id === item.id}
            title={it.title}
            duration={it.duration}
            type={it.type}
            onClick={() => setItem(it)}
          />
        ))}
      </Box>
        <Box
          onClick={() => showRightArrow && scroll('right')}
          sx={{
            borderRadius: 1,
            py: 1,
            px: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: showRightArrow && 'pointer',
            userSelect: 'none',
            backgroundColor: theme.palette.background.paper,
            '&:hover': showRightArrow && {
              backgroundColor: theme.palette.action.hover,
            },
            '&:active': showRightArrow && {
              backgroundColor: theme.palette.action.selected,
            },
            color: !showRightArrow && theme.palette.text.disabled,
          }}
        >
          <ChevronRight sx={{ fontSize: 20 }} />
        </Box>
    </Card>
  );
}
